/* Goods Scene — related products overflow detector.
   Shopify's native <slider-component> owns navigation. This file only decides
   whether navigation is needed and whether a short product set should center. */
(function () {
  function setup(component) {
    if (!component || component.dataset.gsArticleProductsReady === 'true') return;

    var rail = component.querySelector('.gs-article__products-grid');
    var controls = component.querySelector('.gs-article__products-controls');
    if (!rail) return;

    component.dataset.gsArticleProductsReady = 'true';

    function update() {
      var overflowing = rail.scrollWidth > rail.clientWidth + 2;
      component.classList.toggle('is-overflowing', overflowing);
      if (controls) controls.hidden = !overflowing;
    }

    update();

    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(update);
      observer.observe(rail);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    window.addEventListener('load', update, { once: true });
  }

  function init(root) {
    var scope = root || document;
    var components = scope.querySelectorAll('.gs-article__products-slider');
    for (var i = 0; i < components.length; i++) setup(components[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
